//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as eva from 'eva-icons/eva'

export default {
    name: 'EvaIcon',

    props: {
        name: { type: String, required: true },
        width: {
            type: [String, Number],
            default: 24,
        },
        height: {
            type: [String, Number],
            default: 24,
        },
        animation: { type: String, default: '' },
        fill: {
            type: String,
            default: 'inherit',
        },
        center: Boolean,
        reverseX: Boolean,
    },

    computed: {
        icon() {
            if (eva.icons[this.name]) {
                return eva.icons[this.name].contents
            } else {
                console.error('Name of icon is not correct')
                return undefined
            }
        },
        classList() {
            return [
                'eva-hover',
                {
                    'eva--center': this.center,
                    'eva--reverse-x': this.reverseX,
                },
            ]
        },
    },
}
